const pd = [
    { // 0
        tle : `១.អត្តសញ្ញាណ និងព័ត៌មានសាវតារ`, 
        des : `
        - សូមបំពេញលេខកូតសាលារៀនតាមប្រកាស/ អជ្ញាប័ណ្ណ ដែលបានស្នើសុំបើកសាលា។ ឧទាហរណ៏ បើសាលារៀនសុំអជ្ញាប័ណ្ណដល់កម្រិតមធ្យមសិក្សា លេខកូតសាលាគឺជាលេខកូតសាលារៀនមធ្យមសិក្សាទោះបីសាលានោះ ទើបតែដំណើរការត្រឹមកម្រិតមត្តេយ្យ ឬបឋមសិក្សាក៏ដោយ
        - សូមបញ្ជាក់ឱ្យបានច្បាស់នូវក្រសួង ស្ថាប័ន ដែលចេញប្រកាស។
        `
    },
    { // 1
        tle : `១.(ក)នាយក/នាយិកាសាលារៀន`, 
        des : `
            - ឈ្មោះ និងព័ត៌មានសាវតាររបស់នាយក/នាយិកា ឬអ្នកទទួលបន្ទុកសាលារៀនត្រូវបំពេញព័ត៌មានជាក់ស្តែង
            - កម្រិតវប្បធម៌៖ ត្រូវបំពេញកម្រិតសញ្ញាបត្រដែលមានខ្ពស់បំផុត (ឧទាហរណ៍: បរិញ្ញាបត្រ, បណ្ឌិត....)
        ` 
    },
    { // 2
        tle : `១.(ខ)សាលារៀន`, 
        des : `
            - សូមបញ្ជាក់អំពីសាខាសាលារៀនឱ្យបានច្បាស់លាស់
            - សាលាអង្គការ គឺជាសាលារៀនដែលមិនរកប្រាក់ចំណូល ឬជាសាលារៀនដែលជួយបង្រៀនកុមារកំព្រា ឬកុមារមកពីគ្រួសារក្រីក្រ
            - សាលាសាសនា គឺជាសាលារៀនដែលបង្រៀនមុខវិជ្ជាអប់រំសាសនាជាគោល (ឧទាហរណ៍៖ សាលារៀនសាសនាឥស្លាម...។ល។)
            - ចំនួនវេនរៀន៖ ១.បើសិស្ស ១ក្រុម រៀនពេលព្រឹកផង និងរៀនពេលរសៀលផង ហៅថា ១វេន។
                    ​​​​​​​      ​​២.បើសិស្ស ២ក្រុម ផ្សេងគ្នា ១ក្រុមរៀនពេលព្រឹក ១ក្រុមទៀតរៀនពេលរសៀល ហៅថា ២វេន។
        ` 
    },
    { // 3
        tle : `១.(គ)លេខកូដសាលារៀនឆ្នាំមុន`,
        des : `- សូមបំពេញលេខកូដសាលារៀនឆ្នាំមុនតាមកម្រិតសិក្សានីមួយៗជាក់ស្តែងប្រសិនបើជាសាលារៀនដែលបានបើកដំណើរការរួចហើយ
        `
    },
    { // 4
        tle : `២.(ក)សិស្សថ្មី សិស្សឡើងថ្នាក់ និងសិស្សត្រួតថ្នាក់ក្នុងឆ្នាំសិក្សា ២០២៦ - ២០២៧`,
        des : `
           - កុមារអាយុ៣ឆ្នាំ គឺកុមារដែលមានអាយុ ៣៦ខែពេញដោយគិតត្រឹមថ្ងៃទី០១ ខែតុលា ឆ្នាំ២០២៦។  ឧទាហរណ៍ៈកុមារអាយុ ៣ឆ្នាំត្រូវចូលរៀន គឺកុមារដែល កើតក្នុងចន្លោះ ថ្ងៃទី០១ ខែវិច្ឆិកា ឆ្នាំ២០២២ ដល់ថ្ងៃទី០១ ខែតុលា ឆ្នាំ២០២៣។
           - កុមារដែលមានអាយុ៦ឆ្នាំ គឺកុមារដែលមានអាយុ៧២ខែពេញ ដោយគិតត្រឹមថ្ងៃទី០១ ខែតុលា ឆ្នាំ២០២៦។  ឧទាហរណ៍ៈកុមារអាយុ ៦ ឆ្នាំត្រូវចូលរៀន គឺ កុមារដែលកើតក្នុង ចន្លោះ ថ្ងៃទី០១ ខែវិច្ឆិកា ឆ្នាំ២០២០ ដល់ថ្ងៃទី០១ ខែតុលា ឆ្នាំ២០២០។
           - សិស្សដែលមានអាយុ១២ឆ្នាំ គឺសិស្សដែលមានអាយុ១២ឆ្នាំដោយគិតត្រឹមថ្ងៃទី០១ ខែតុលា ឆ្នាំ២០២៦។  ឧទាហរណ៍ៈកុមារអាយុ ១២ ឆ្នាំត្រូវចូលរៀន គឺកុមារដែលកើតក្នុង ចន្លោះ ថ្ងៃទី៣០ ខែតុលា ឆ្នាំ២០១៣ ដល់ថ្ងៃទី០១ ខែតុលា ឆ្នាំ២០១៤។
        `
    },
    { // 5
        tle : `២.(ខ)សិស្សថ្មីតាមអាយុនិងតាមកម្រិតថ្នាក់ដែលកំពុងរៀនទាំងសាលារដ្ឋ/សាលាផ្សេងទៀត`,
        des : `
            - សំដៅលើសិស្សដែលរៀនសាលារដ្ឋ/សាលាផ្សេងពេលព្រឹក រៀនសាលាឯកជនពេលរសៀល ឬរៀនសាលារដ្ឋ/សាលាផ្សេងពេលរសៀល ហើយរៀនសាលា ឯកជនពេលព្រឹក
        `
    },
    { // 6
        tle : `២.(គ)សិស្សពិការ សិស្សជួបការលំបាកផ្នែកសុខភាព និងសិស្សជួបការលំបាកតាមកម្រិតថ្នាក់`,
        des : `
        - ពិបាកក្នុងការធ្វើចលនា ៖ ដាច់ដៃ ដាច់ជើង    ស្វិតដៃ   ស្វិតជើង  ស្វិតសាច់ដុំ  គាំងសន្លាក់  បាក់ឆ្អឹង  សាច់ដុំរួញ   ខូចប្រព័ន្ធបញ្ជាចលនារបស់ខួរក្បាល ។
        - ជើងខ្វេរ ជើងកែក ជើងទន់ ខូចទ្រង់ទ្រាយពីកំណើត ស្លាប់មួយចំហៀងខ្លួន កំហូចឆ្អឹងខ្នង (កោងទៅមុខ កោងទៅចំហៀង និងកោងទៅក្រោយ) ពិការដោយសាផលវិបាកនៃជំងឺ ខូចស្មាម្ខាង គ្រេចធ្ងន់ធ្ងរ រលាកធ្ងន់ធ្ងរ (ភ្លើង ទឹកអាស៊ីត...)។
        - ពិបាកក្នុងការស្ដាប់៖ ថ្លង់ ត្រចៀកអត់រន្ធ ពុំមានក្រដាសត្រចៀក ធ្លាយក្រដាសត្រចៀក ហៀរអំបៅអំបែកធ្ងន់ធ្ងរ រន្ធត្រចៀកមានដុំពក។
        - ពិបាកក្នុងការនិយាយ៖ និយាយត្រឡាន់ (អណ្ដាតធំ) ត្រដិតធ្ងន់ធ្ងរ ឆែបក្រអូម មាត់ ក្រឡើត ក្រងួរ  និយាយមិនច្បាស់ និយាយមិនចេញ។
        - ពិបាកក្នុងការមើល៖ ងងឹតភ្នែកម្ខាង ឬទាំងសងខាង ស្វិតសរសៃបាតភ្នែក     ភ្នែកលៀនមើលមិនឃើញ កន្ទុយថ្លែនធ្ងន់ធ្ងរ ភ្នែកឡើងបាយ ត្រាក់កូមធ្ងន់ធ្ងរ បណ្ដាលឱ្យមានប្រែងចាក់ភ្នែក ស្រលៀង ភ្នែកមីញ៉ូក ធ្លាក់ត្របកភ្នែក សម្លាកកញ្ចក់ភ្នែក សម្ពាធទឹកក្នុងភ្នែកកើន ឡើងរលាកសរសៃបាតភ្នែក ងងឹតពណ៌។
        - ពិការសរីរាង្គខាងក្នុង៖ ខ្សោយមុខងារសរីរាង្គ បេះដូង  ក្រលៀន ប្រព័ន្ធដង្ហើម តម្រងនោម  ពោះវៀន  ថ្លើម។
        - ពិការសតិបញ្ញា៖ បញ្ញាលូតលាស់យឺត រៀនខ្សោយ / ការចងចាំមានកម្រិត  ខូចប្រព័ន្ធបញ្ជាក្នុងខួរក្បាល និងជំងឺ(ដោនស៊ីនដ្រូម មានចរឹកទុយមុយ)
        - ពិការផ្លូវចិត្ត៖ អាក្រាត និយាយ សើច យំ ច្រៀងរាំ លេងតែម្នាក់ឯងខុសពីប្រក្រតី  ស្មឹងស្មាធិ៍ ជេរគេជេរឯង វាយ ឬ ប្រព្រឹត្តអំពើហិង្សាដោយមិនដឹងខ្លួន មិនដឹងគ្រោះថ្នាក់ ជំងឺមន្ទិលសង្ស័យ  វិកលចរិត  ខូចសតិអារម្មណ៍  តានតឹងផ្លូវចិត្ត ជំងឺធ្លាក់ទឹកចិត្ត ថប់អារម្មណ៍ ជំងឺវង្វេង ។
        - ពិការផ្សេងៗ៖ មុខមាត់ខូចទ្រង់ទ្រាយ ក្បាលធំ តឿ ក្រិន ពកក ផលវិបាកក្នុងការបំពេញមុខងារ ដោយសារគ្រោះថ្នាក់ និងជំងឺរ៉ាំរ៉ៃ ។ល។
        - ខ្វះអាហារូបត្ថម្ភធ្ងន់ធ្ងរ៖ កំណត់ដោយទម្ងន់ទាបខ្លាំងធៀបនឹងកម្ពស់ (ទាបជាងពិន្ទុ -3 Z-score ឬ <-3SD នៃខ្សែកោងលូតលាស់នៃទម្ងន់ធៀបនឹងប្រវែង/កម្ពស់របស់អង្គការសុខភាពពិភពលោក) ដោយការបាត់បង់ធ្ងន់ធ្ងរដែលអាចមើលឃើញឬដោយវត្តមាននៃការហើម។
        - កុមាររងគ្រោះដោយ HIV/AIDS៖ កុមារដែលបាត់បង់ឪពុកឬម្តាយ ឬទាំងពីរ ដោយរងផលប៉ះពាល់ដោយសារ HIV/AIDS ងាយរងគ្រោះដោយការឆ្លងHIV/AIDS។
        - កុមារដែលមកពីគ្រួសារក្រីក្រ៖ គ្រួសារដែលរកប្រាក់ចំណូល ៥០០០រៀលក្នុងមួយថ្ងៃ(១,២៥ដុល្លា) ឬ ដែលចំណាយលើរបបស្បៀងអាហារប្រចាំថ្ងៃ ៣៧០០រៀល ក្នុងមួយថ្ងៃ។ បើរកបានក្រោមនេះ ស្ថិតក្នុងចំណាត់ទីទ័លក្រ  បើរកបានស្មើ ឬលើសបន្តិចបន្តួច ស្ថិតក្នុងចំណាត់ ក្រីក្រ។ 
        `
    },
    { // 7
        tle : `២.(ឃ)ចំនួនសិស្ស ក្នុងឆ្នាំសិក្សា ២០២៥-២០២៦`,
        des : `
        - ចំនួនសិស្សដើមឆ្នាំសិក្សា២០២៥-២០២៦៖ ជាចំនួនសិស្សថ្មីសរុបជាក់ស្តែង ដែលបានរៀនតាមថ្នាក់នីមួយៗក្នុងតារាង២(ក) នៃតារាងជំរឿនស្ថិតិសាសារៀនប្រចាំឆ្នាំ២០២៥-២០២៦។
        - ចំនួនសិស្សចុងឆ្នាំសិក្សា២០២៥-២០២៦៖ ជាចំនួនសិស្សសរុបដែលបាននៅរៀនជាក់ស្តែងក្នុងសាលារៀនពេលចុងឆ្នាំសិក្សា២០២៥-២០២៦នោះ។
        - ចំនួនសិស្សត្រូវបានឡើងថ្នាក់ និងជាប់សញ្ញាបត្រ២០២៥-២០២៦៖ ជាចំនួនសិស្សសរុបដែលបានប្រឡងជាប់មធ្យមភាគប្រចាំឆ្នាំ និងបានប្រឡងជាប់។
        - ចំនួនសិស្សផ្ទេរចូល២០២៦-២0២៧ គឺជាចំនួនសិស្សដែលបានផ្ទេរមកចូលរៀននៅដើមឆ្នាំសិក្សាថ្មី២០២៦-២0២៧។
        - ចំនួនសិស្សផ្ទេរចេញ២០២៥-២0២៦ គឺជាចំនួនសិស្សដែលបានផ្ទេរចេញទៅសាលារៀនផ្សេងក្នុងឆ្នាំសិក្សា២០២៥-២0២៦។
        - ចំនួនសិស្សផ្ទេរចូល ឬចេញ២០២៥-២០២៦៖ ចំនួនសិស្សសរុបដែលបានផ្ទេរចូលពីសាលាផ្សេង ឬចេញក្នុងឆ្នាំសិក្សា ២០២៥-២០២៦។
        - ចំនួនកុមារអាយុ៥ឆ្នាំមានការអភិវឌ្ឍផ្នែកទាំង៥បានល្អប្រសើរសំដៅលើកុមារដែល៖ ១. អភិវឌ្ឍផ្នែកសីលធម៌ និងវប្បធម៌ ២. អភិវឌ្ឍផ្នែកសុខភាព និងរាង កាយ ៣. អភិវឌ្ឍផ្នែកភាសា ៤. អភិវឌ្ឍផ្នែកបញ្ញា និងការគិត ៥. អភិវឌ្ឍផ្នែកសង្គម និងអារម្មណ៍។
        `
    },
    { // 8
        tle : `២.(ខ.៤)ចំនួនថ្នាក់រៀន សិស្ស រៀនកម្មវិធីសិក្សាអន្តរជាតិសុទ្ធសាធ ក្នុងឆ្នាំសិក្សា២០២៦ - ២០២៧`,
        des : `
        - សំដៅលើចំនួនសិស្សដែលរៀនតែកម្មវិធីសិក្សាអន្តរជាតិសុទ្ធ
        `
    },
    { // 9
        tle : `៣.បន្ទប់រៀន ថ្នាក់រៀន និងកម្មវិធីសិក្សា`,
        des : `
        - បន្ទប់រៀន គឺជាបន្ទប់ប្រើប្រាស់សម្រាប់សិស្សអង្គុយរៀន អាចបន្ទប់រៀនមួយប្រើពីរកម្រិតថ្នាក់។ ឧទាហរណ៍ ពេលព្រឹករៀនថ្នាក់ទី៧ “ ក ” ពេលរសៀលរៀន ថ្នាក់ទី៨ “ ខ ” ។
        - ­ថ្នាក់រៀន គឺជាចំនួនថ្នាក់តាមកម្រិតថ្នាក់នីមួយៗ ឧទាហរណ៍ : ថ្នាក់ទី៧ មាន៣ថ្នាក់រៀនគឺ ថ្នាក់ទី៧ “ ក “ ថ្នាក់ទី៧ “ ខ “ ថ្នាក់ទី៧ “ គ “ .... ។ 
        - កម្មវិធីសិក្សា គឺជាកម្មវិធីដែលប្រើសម្រាប់បង្រៀនសិស្សដោយយកតាមកម្មវិធីសិក្សាជាតិរបស់ក្រសួងអប់រំ យុវជន និងកីឡា ឬកម្មវិធីសិក្សាអន្តរជាតិពី ប្រទេសណាមួយ។
        - ចំនួនម៉ោងបង្រៀនជាភាសាខ្មែរក្នុង១សប្តាហ៍ ជាចំនួនម៉ោងបង្រៀនមុខវិជ្ជាផ្សេងៗជាភាសាខ្មែរ ដូចជា មុខវិជ្ជាគណិតវិទ្យា និងវិទ្យាសាស្រ្តជាដើម ។
        - ចំនួនម៉ោងបង្រៀនជាភាសាបរទេសក្នុង១សប្តាហ៍ ជាចំនួនម៉ោងបង្រៀនមុខវិជ្ជាផ្សេងៗជាភាសាបរទេស មិនមែនសំដៅមុខវិជ្ជាភាសាបរទេសទេ។
        `
    },
    { // 10
        tle : `៤.បុគ្គលិកបង្រៀន និងបុគ្គលិកមិនបង្រៀន`,
        des : `
        - ចំពោះសាលារៀនដែលមានពីរឬបីកម្រិតសិក្សា (មត្តេយ្យសិក្សា បឋមសិក្សា មធ្យមសិក្សា) សូមបំពេញតែគ្រូបង្រៀននៅកម្រិតសិក្សានោះ ជៀសសវាងការរាប់ត្រួតគ្នា២ ឬ៣ដង ។
        - បុគ្គលិករដ្ឋ គឺជាបុគ្គលិកដែលមានក្របខណ្ឌរដ្ឋ ហើយដែលកំពុងបម្រើការងារបច្ចុប្បន្ននៅសាលារៀនសាធារណៈ ហើយមកបង្រៀននៅសាលារៀនឯកជន យកប្រាក់កម្រៃ។
        - បុគ្គលិកបរទេស គឺជាគ្រូបង្រៀនជនជាតិបរទេសដែលមកបង្រៀននៅសាលារៀននោះ។
        - បុគ្គលិកដែលបានឆ្លងកាត់ការបណ្តុះបណ្តាលគរុកោសល្យ និងវិក្រឹតការ ជាបុគ្គលិកដែលបានឆ្លងកាត់ការបណ្តុះបណ្តាលនៅវិទ្យាស្ថានជាតិអប់រំ ឬវិទ្យាស្ថាន គរុកោសល្យ ឬគរុកោសល្យ និងវិក្រឹតការភូមិភាគ ឬខេត្ត។
        `
    },
    { // 11
        tle : `៥.(ក).ផ្ទៃដីរបស់សាលារៀន`,
        des : `
        - បើផ្ទៃដីសាលារៀនជាកម្មសិទ្ធិរបស់សាលាផ្ទាល់ សូមបំពេញផ្ទៃដីសរុបគិតជាម៉ែត្រការ៉េ(ម២)
        - បើជាអគារជួលសូមបំពេញតែផ្ទៃក្រឡាបន្ទប់រៀនទាំងអស់សម្រាប់កម្រិតសិក្សារបស់ខ្លួនប្រើប្រាស់។ រង្វាស់ផ្ទៃក្រឡាដីត្រូវគិតជាម៉ែត្រការ៉េ (ម២)ហើយជា ចំនួនគត់។
        - ផ្ទៃក្រឡាបន្ទប់រៀនទាំងអស់គឺជាផ្ទៃខាងក្នុងគ្រប់បន្ទប់រៀនទាំងអស់(គ្រប់ជាន់)ដោយមិនគិតផ្ទៃរានហាល។
        `
    },
    { // 12
        tle : `៥.(ខ).អំពីអគារសិក្សា`,
        des : `
        - ចំនួនបន្ទប់សូមរាប់ចំនួនបន្ទប់ទាំងអស់ដែលសាលារៀនមាន (បន្ទប់ការិយាល័យ បន្ទប់រៀន បន្ទប់ពិសោធន៍ បន្ទប់ប្រជុំ បន្ទប់អាន សៀវភៅ/បណ្ណាល័យ បន្ទប់នាយក/នាយិកា បន្ទប់គ្រូ៘) ។ 
        - ក្នុងករណីសាលារៀនមានច្រើនកម្រិតសិក្សា សូមរាប់បន្ទប់ផ្សេងៗ បញ្ចូលក្នុងតារាងជំរឿន ស្ថិតិ របស់កម្រិតសិក្សាដែលខ្ពស់ជាងគេ និងរាប់ចំនួនអគារទាំងអស់។ ឯកម្រិតសិក្សាទាបជាងរាប់តែបន្ទប់ ប្រើសម្រាប់បង្រៀនប៉ុណ្ណោះ ហើយចំនួន អគារ មិនបាច់ បំពេញទេ។
        `
    },
    { // 13
        tle : `៥.(គ).ស្ថានភាពអគារ បន្ទប់ និង បរិក្ខារ`,
        des : `
        សូមគូសរង្វង់មាន ឬគ្មាន ចំពោះបន្ទប់ដែលមានមុខងារដោយឡែកដូចជា ទីចាត់ការ បណ្ណាល័យ បន្ទប់កុំព្យូទ័រ ..... និងស្ថានភាពល្អ/មធ្យម/អន់។ សាលារៀន ដែល មាន ទីជម្រាលសម្រាប់សិស្សពិការ និងប្រអប់សង្គ្រោះបឋម ត្រូវរាប់ចំនួន។
        - ល្អ មានន័យថា បច្ចុប្បន្ននេះស្ថិតក្នុងស្ថានភាពល្អ ហើយនិងមិនចាំបាច់ជួសជុលទេ។
        - មធ្យម មានន័យថា មានតម្រូវការជួសជុល ប៉ុន្ដែអាចនៅប្រើប្រាស់បានក្នុងរយៈពេលពី ២-៣ ឆ្នាំខាងមុខទៀត។
        - អន់ មានន័យថា មិនអាចប្រើប្រាស់កើតទេ ចាំបាច់ត្រូវតែជួសជុលក្នុងពេលចំពោះមុខនេះ។
        `
    },
    { // 14
        tle : `៥.(ង).បង្គន់រួម`,
        des : `
        - ជាបង្គន់ដែលប្រើប្រាស់រួមគ្នាទាំងសិស្ស ទាំងគ្រូ។
        `
    },
    { // 15
        tle : `៥.(ឆ).សម្ភារបរិក្ខារ`,
        des : `
        - កុំព្យូទ័រសម្រាប់ការិយាល័យ៖ ជាកុំព្យូទ័រដែលអាចប្រើប្រាស់បាន សម្រាប់ការងារក្នុងការិយាល័យ ឬការងារផ្សេងៗក្រៅពីការបង្រៀន និងរៀន។
        - កុំព្យូទ័រសម្រាប់ការបង្រៀន និងរៀន៖ ជាកុំព្យូទ័រដែលអាចប្រើប្រាស់បាន សម្រាប់ការងារបង្រៀន និងរៀន។
        - ប្រអប់សង្រ្គោះបឋម និងសម្ភារបម្រុង៖ សំដៅលើប្រអប់ចល័ត ឬអចល័តដែលមានសម្ភារៈបម្រុងខាងក្នុង បើសិនជាមានតែប្រអប់គ្មានសម្ភារៈមិនត្រូវបានរាប់ បញ្ចូលទេ។
        `
    },
    { // 16
        tle : `៦.តម្លៃសិក្សាតាមកម្រិតថ្នាក់`,
        des : `
        - តម្លៃសិក្សាត្រូវគិតជាដុល្លារសហរដ្ឋអាមេរិកក្នុង១នាក់ក្នុង១ឆ្នាំសិក្សា។
        `
    },
    { // 17
        tle : `៦.៤.ថវិកាដំណើរការសាលារៀន`,
        des : `
        - សូមបញ្ជាក់ប្រភពថវិកាឱ្យបានច្បាស់លាស់។
        `
    },
    { // 18
        tle : `៧.ការចែកចាយថ្នាំព្រូនក្នុងឆ្នាំសិក្សា ២០២៥-២០២៦`,
        des : `
        - គណៈគ្រប់គ្រងសាលាត្រូវធ្វើសំណើសុំថ្នាំទម្លាក់ព្រូនឱ្យបានមួយខែមុននៃជុំនីមួយៗ (ជុំទី១ ខែវិច្ឆិកា និងជុំទី២ ខែឧសភា)។ សាលាត្រូវធ្វើបាយការណ៍មួយ ច្បាប់ផ្ញើទៅមណ្ឌលសុខភាពនិងមួយច្បាប់ទៀតទៅការិយាល័យអប់រំ យុវជន និងកីឡា នៃរដ្ឋបាល ក្រុង ស្រុក ខណ្ឌ។
        `
    }
]

export {
    pd
}